import { defineStore } from 'pinia'
import type { AuthInfo } from '~/types/interfaces'

export const useAuthInfoStore = defineStore(
  '_cam_auth_info',
  () => {
    const sub = ref<string>('')
    const cognitoUsername = ref<string>('')
    const exp = ref<number>(0)
    const idToken = ref<string>('')
    const accessToken = ref<string>('')
    const refreshToken = ref<string>('')

    const authInfo = computed<AuthInfo>(() => {
      return {
        sub: sub.value,
        cognitoUsername: cognitoUsername.value,
        exp: exp.value,
        idToken: idToken.value,
        accessToken: accessToken.value,
        refreshToken: refreshToken.value,
      }
    })
    const isAuthenticated = computed<boolean>(() => {
      const isAuthenticated = (
        !!sub.value
        && exp.value > Date.now() / 1000
        && !!accessToken.value
        && !!refreshToken.value
      )
      console.log(`[AuthInfoStore.isAuthenticated] ${isAuthenticated}`)
      return isAuthenticated
    })

    const setAuthInfo = (authInfo: AuthInfo): void => {
      // console.log('setAuthInfo', authInfo)
      console.log('[AuthInfoStore.setAuthInfo] auth info saved.')
      sub.value = authInfo.sub
      cognitoUsername.value = authInfo.cognitoUsername
      exp.value = authInfo.exp
      idToken.value = authInfo.idToken
      accessToken.value = authInfo.accessToken
      refreshToken.value = authInfo.refreshToken
    }
    const resetAuthInfo = (): void => {
      sub.value = ''
      cognitoUsername.value = ''
      exp.value = 0
      idToken.value = ''
      accessToken.value = ''
      refreshToken.value = ''
    }

    return {
      sub,
      cognitoUsername,
      exp,
      idToken,
      accessToken,
      refreshToken,
      authInfo,
      isAuthenticated,
      setAuthInfo,
      resetAuthInfo,
    }
  },
  {
    // localStorage で永続化する (#596)。
    // 過去 cookie 永続化を使っていたが、pinia-plugin-persistedstate の
    // cookies adapter は内部で Nuxt の useCookie を呼び、これが Pinia の
    // $subscribe コールバック (Vue scope 外) で正しく document.cookie に
    // 反映されない不具合があった。localStorage adapter は window.localStorage
    // 直叩きのため Vue scope に依存しない。
    // SSR で読めなくなる影響は middleware を CSR 限定に変更したため無し。
    persist: {
      storage: piniaPluginPersistedstate.localStorage(),
    },
  },
)
